import Button from "../../../../atoms/Button";
import { AiFillFileAdd, AiOutlineInfo } from "react-icons/ai";
import CardHeader from "../../../../atoms/CardHeader";
import Breadcrumb from "../../../../molecules/Breadcrumb";
import { getTabla } from "../../../../../utils/getTablas";
import { useTipos } from "../../../../../hooks/useTipos";
import useModal from "../../../../../hooks/useModal";
import Modal from "../../../../molecules/Modal";
import InfoEmpresa from "../../../../templates/clientes/InfoEmpresa";

const DocumentsTemplateHeader = ({ empresa, user, tabla, tipo, open }) => {
    const tipoTexto = useTipos(tipo);
    const { open: openInfo, close, isOpen } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                    { label: "CONTABILIDAD", to: `/clientes/empresas/${empresa?.id}` },
                    { label: `${getTabla(tabla)}`, to: `/clientes/empresas/${empresa?.id}/${tabla}` },
                    { label: `${tipoTexto}`, to: null },
                ]}
            />
            {user?.role !== "Client" ?
                <div className="flex flex-row gap-2">
                    <Button
                        text={<AiOutlineInfo size={22} />}
                        bgColor="black"
                        width="w-10"
                        onClick={openInfo}
                    />
                    <Button text={<AiFillFileAdd size={22} />} bgColor="green" onClick={open} width="w-10" />
                </div>
            :
                <Button
                    text={<AiOutlineInfo size={22} />}
                    bgColor="black"
                    width="w-10"
                    onClick={openInfo}
                />
            }
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
        </CardHeader>
    )
};

export default DocumentsTemplateHeader;